module.exports = __webpack_public_path__ + "img/glasses-5.d0353695.svg";